import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective } from '@ngx-translate/core';
import { AutofocusDirective } from '../autofocus/autofocus.directive';

@Component({
  selector: 'app-confirm-override-dialog',
  templateUrl: './confirm-override-dialog.component.html',
  imports: [TranslateDirective, AutofocusDirective],
})
export class ConfirmOverrideDialogComponent {
  protected modal = inject(NgbActiveModal);

  @Input()
  public confirmationText!: string;
}
